module.exports = __webpack_public_path__ + "static/media/28_A.b9368c42.png";